import { render, staticRenderFns } from "./_formGroup.vue?vue&type=template&id=40fc7c3c&"
import script from "./_formGroup.vue?vue&type=script&lang=js&"
export * from "./_formGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports